/**
=========================================================
* Material Dashboard 2 React - v2.2.0
=========================================================

* Product Page: https://www.creative-tim.com/product/material-dashboard-react
* Copyright 2023 Creative Tim (https://www.creative-tim.com)

Coded by www.creative-tim.com

 =========================================================

* The above copyright notice and this permission notice shall be included in all copies or substantial portions of the Software.
*/

// @mui material components
import Grid from "@mui/material/Grid";

// Material Dashboard 2 React components
import MDBox from "components/MDBox";

// Material Dashboard 2 React example components
import DashboardLayout from "examples/LayoutContainers/DashboardLayout";
import DashboardNavbar from "examples/Navbars/DashboardNavbar";

// Data
import reportsLineChartData from "pages/dashboard/data/reportsLineChartData";
import TimeSheetListing from "pages/Technician/TimeSheetListing";
import { Card, Icon } from "@mui/material";
import MDTypography from "components/MDTypography";
import colors from "assets/theme/base/colors";

// Dashboard components

function Dashboard() {
  const { sales, tasks } = reportsLineChartData;

  return (
    <DashboardLayout>
      <DashboardNavbar />
      {/* <MDBox px={3} pb={2} mt={5}>
        <Grid container spacing={2}>
          {[
            {
              label: "Present Days",
              value: 7,
              color: "success",
              icon: "check_circle",
            },
            {
              label: "Pending Approvals",
              value: 3,
              color: "secondary",
              icon: "pending_actions",
            },
            {
              label: "Hours in Month",
              value: 192,
              color: "info",
              icon: "undo",
            },
            {
              label: "Overtime Hours",
              value: 10,
              color: "primary",
              icon: "schedule",
            },
          ].map((item) => (
            <Grid item xs={12} sm={6} md={3} key={item.label}>
              <Card
                sx={{
                  borderRadius: 3,
                  overflow: "hidden",
                  position: "relative",
                  boxShadow: "0 6px 18px rgba(0,0,0,0.06)",
                  transition: "0.3s",
                  "&:hover": {
                    transform: "translateY(-4px)",
                    boxShadow: "0 10px 25px rgba(0,0,0,0.1)",
                  },
                }}
              >
                <MDBox
                  sx={{
                    position: "absolute",
                    left: 0,
                    top: 0,
                    bottom: 0,
                    width: "6px",
                    background: colors[item.color].main,
                  }}
                />

                <MDBox p={2.5} pl={3}>
                  <MDBox
                    display="flex"
                    justifyContent="space-between"
                    alignItems="center"
                  >
                    <MDBox>
                      <MDTypography
                        variant="button"
                        sx={{
                          color: colors.secondary.main,
                          fontWeight: 500,
                          letterSpacing: "0.5px",
                        }}
                      >
                        {item.label}
                      </MDTypography>

                      <MDTypography
                        variant="h5"
                        fontWeight="bold"
                        sx={{ color: colors.deepBlue }}
                      >
                        {item.value}
                      </MDTypography>
                    </MDBox>

                    <MDBox
                      sx={{
                        width: 48,
                        height: 48,
                        borderRadius: "12px",
                        display: "flex",
                        alignItems: "center",
                        justifyContent: "center",
                        background: `linear-gradient(135deg, ${colors[item.color].main}22, ${colors[item.color].main}55)`,
                      }}
                    >
                      <Icon sx={{ colors: colors[item.color].main }}>
                        {item.icon}
                      </Icon>
                    </MDBox>
                  </MDBox>
                </MDBox>
              </Card>
            </Grid>
          ))}
        </Grid>
      </MDBox> */}
      <MDBox>
        <Grid container spacing={3}>
          <Grid item xs={12}>
            <TimeSheetListing />
          </Grid>
        </Grid>
      </MDBox>
    </DashboardLayout>
  );
}

export default Dashboard;
